import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';

export const ENDPOINT_POST_BCM_PAYMENT_METHOD = `${backendBaseUrl}/v1/bcm/subscription/payment-method`;

/**
 * Attaches a one-time card token (from utils/tokenizeCard — browser-side
 * tokenization, the PAN never reaches Tento) to the account's BCS
 * subscription. Body: { accountPublicId, cardToken }.
 */
export const postBcmPaymentMethod = () =>
  useAxios(
    {
      url: ENDPOINT_POST_BCM_PAYMENT_METHOD,
      withCredentials: true,
      method: 'POST',
    },
    { manual: true }
  );
